import { SESSION_DRAFT_KEY } from "@/constants/ab-tests";
import type { IntentType, ContentType, ABTestType } from "@/types/ab-tests";
import type { ScorecardGapSnapshot } from "./create-test-modal.types";

export interface SessionDraft {
  step: 1 | 2;
  testType?: ABTestType | null;
  selectedFields: ContentType[];
  targetPhrase: string;
  intentFrom: IntentType;
  intentTo: IntentType | "";
  hypothesis: string;
  variantBTitle: string;
  variantBBullets: Record<string, string>;
  variantBMode: "use-ai" | "starting-point" | "manual-editor";
  source: string | null;
  sourceDetail: string;
  appliedScorecardGaps: string[];
  gapSnapshots?: Record<string, ScorecardGapSnapshot>;
  heroAsinId: string;
  /**
   * AUT-430 (WEB-008): present only when the state at write time was a number
   * or `null` -- `JSON.stringify` drops an `undefined` value, so "as stored"
   * is never written here. Reading a draft written by an older bundle finds
   * no key at all; the reader falls back to `initialStrategyLinkId` for both
   * cases, since it cannot tell them apart (`components/ab-test.md §
   * Session draft`).
   */
  strategyLinkId?: number | null;
}

export function readSessionDraft(): SessionDraft | null {
  try {
    const raw = sessionStorage.getItem(SESSION_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SessionDraft;
  } catch {
    return null;
  }
}

export function writeSessionDraft(draft: SessionDraft) {
  try {
    sessionStorage.setItem(SESSION_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    return;
  }
}

export function clearSessionDraft() {
  try {
    sessionStorage.removeItem(SESSION_DRAFT_KEY);
  } catch {
    return;
  }
}
